import cbx from './cbx.json';
import common from './common.json';

const es = {
  ...common,
  cbx,
};

export default es;
